import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../utils/propUtils';
import VeltRecorderAllToolMenuAudioWireframe from './VeltRecorderAllToolMenuAudioWireframe/VeltRecorderAllToolMenuAudioWireframe';
import VeltRecorderAllToolMenuVideoWireframe from './VeltRecorderAllToolMenuVideoWireframe/VeltRecorderAllToolMenuVideoWireframe';
import VeltRecorderAllToolMenuScreenWireframe from './VeltRecorderAllToolMenuScreenWireframe/VeltRecorderAllToolMenuScreenWireframe';
var VeltRecorderAllToolMenuWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-recorder-all-tool-menu-wireframe", __assign({}, transformedProps), children));
};
VeltRecorderAllToolMenuWireframe.Video = VeltRecorderAllToolMenuVideoWireframe;
VeltRecorderAllToolMenuWireframe.Audio = VeltRecorderAllToolMenuAudioWireframe;
VeltRecorderAllToolMenuWireframe.Screen = VeltRecorderAllToolMenuScreenWireframe;
export default VeltRecorderAllToolMenuWireframe;
